document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.nav-toggle');
  const nav = document.querySelector('#site-nav');
  if (toggle && nav) toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    nav.classList.toggle('is-open', !open);
  });

  document.querySelectorAll('[data-checklist-search]').forEach(input => {
    const target = document.querySelector(input.dataset.target || '#checklist-body');
    if (!target) return;
    input.addEventListener('input', () => {
      const q = input.value.trim().toLowerCase();
      target.querySelectorAll('tr').forEach(row => {
        row.hidden = q && !row.textContent.toLowerCase().includes(q);
      });
    });
  });
});
